import { Link } from 'react-router-dom';
import HeaderBlue from '../../components/HeaderBlue';
import FooterBlue from '../../components/FooterBlue';

import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import api from '../../utils/axiosInstance';

const HomeBlue = () => {
    const navigate = useNavigate();
    const [packages, setPackages] = useState([]);
    const [formData, setFormData] = useState({ name: '', email: '' });
    const [popupMessage, setPopupMessage] = useState('');

    const [specialPackage, setSpecialPackage] = useState(null);

    useEffect(() => {
        api.get('/packages/active')
            .then((res) => {
                // const standardPackage = res.data.filter((pkg) => pkg.name === 'Standard Package');
                // setPackages(standardPackage);
                if (Array.isArray(res.data)) {
                    const sortedPackages = res.data.sort((a, b) => a.price - b.price);
                    setPackages(sortedPackages);
                }
            })
            .catch((err) => console.error('Failed to fetch packages:', err));

        //fetch the special package alongside regular packages
        const fetchSpecialPackage = async () => {
            try {
                const res = await api.get('/special-package/details');

                if (res.data.success) {
                    setSpecialPackage(res.data.package);
                }
            } catch (err) {
                console.error('Could not load special package:', err);
            }
        };

        fetchSpecialPackage();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.post('/send-newsletter', formData);

            // Show popup
            setPopupMessage('E-mail sent successfully!');
            setTimeout(() => setPopupMessage(''), 2000);

            setFormData({ name: '', email: '' });
        } catch (err) {
            console.error(err);
            setPopupMessage('Something went wrong. Try again later.');
            setTimeout(() => setPopupMessage(''), 2000);
        }
    };

    return (
        <>
            <HeaderBlue />
            {/* Hero Section */}
            <div className='relative w-full h-screen mx-auto overflow-hidden z-40'>
                <div className='slide relative w-full h-full '>
                    <video autoPlay muted loop playsInline className='absolute inset-0 w-full h-full object-cover z-0 '>
                        <source src='./assets/indexvideo.webm' type='video/webm' />
                        Your browser does not support the video tag.
                    </video>

                    <div className='relative top-28 md:top-6 inset-0 z-10 flex justify-center flex-col px-8 md:px-20 md:h-screen'>
                        <div className='text-left font-bold text-white staffx text-6xl leading-tight lg:text-7xl'>
                            CONNECTING <br />
                            <span className='b900 staffx'>CARRIERS</span> <br />
                            WITH QUALIFIED
                            <br />
                            <span className='b900 staffx'>DRIVERS</span>
                        </div>
                        <p className='text-white text-xl mt-6 text-left'>
                            Drivers at Your Fingertips — Flat fees, No Markups.
                        </p>
                        <div className='flex gap-5 mt-5'>
                            <Link
                                to='/carrier-registration'
                                className='text-white text-xl px-7 py-3 rounded-md bg-[#3c9bf9] hover:bg-white hover:text-[#3c9bf9] border border-[#3c9bf9] transition-all'
                            >
                                Get Started
                            </Link>

                            <Link
                                to='/book-demo'
                                className='text-[#3c9bf9] text-xl px-7 py-3 rounded-md bg-white hover:bg-[#3c9bf9] hover:text-white border border-[#3c9bf9] transition-all'
                            >
                                Book Demo
                            </Link>
                        </div>
                    </div>
                    <div className='absolute inset-0 bg-black bg-opacity-50 z-5'></div>
                </div>
            </div>

            {/* How It Works Section */}
            <section
                className='bg-gray-50 md:pb-40 pt-10  px-4 sm:px-8 lg:px-24 flex items-center text-left'
                style={{
                    background: "url('assets/BENBGBluesmall.webp')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
                id='learnmore'
            >
                <div className='w-full  mx-auto text-center'>
                    <h2
                        className='section-titlelEFT leading-tight text-gray-800 staffx'
                        style={{
                            fontSize: 50,
                            textAlign: 'left',
                            textDecorationThickness: '3px',
                            marginBottom: '22px',
                        }}
                    >
                        How It Works
                    </h2>

                    <div className='text-lg font-normal interfont text-left mb-6'>
                        Our platform helps you connect directly with verified truckers, no middlemen, no hassle. <br />
                        Simplify your logistics, reduce costs, and manage your transport operations with ease.
                    </div>
                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 w-full pb-4'>
                        {/* Step 1 */}
                        <div className='bg-white shadow-xl rounded-2xl p-4 hover:shadow-2xl transition duration-300 group zoomeffect relative'>
                            <div className='mx-auto w-40 mb-2 flex items-center justify-center bg-indigo-100 text-indigo-600 text-2xl rounded-full font-bold group-hover:bg-indigo-600 group-hover:text-white transition'>
                                <img src='assets/icons/SUBSCRIBEICONsmall.webp' alt='Subscribe' />
                            </div>
                            <h3 className='text-xl font-semibold text-gray-800 mb-2 staffx group-hover:text-blue-500'>
                                Subscribe to Our Platform
                            </h3>
                            <p className='text-gray-600 text-md font-normal interfont'>
                                Join us to unlock access to a large network of <br />
                                reliable truckers across the region.
                            </p>
                            <div className='bg-slate-400 w-16 h-16 p-5 text-white rounded-full absolute md:-right-10 md:top-24 z-10 rotate-50'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    fill='none'
                                    viewBox='0 0 24 24'
                                    stroke-width='3'
                                    stroke='currentColor'
                                    className='size-6'
                                >
                                    <path
                                        stroke-linecap='round'
                                        stroke-linejoin='round'
                                        d='M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3'
                                    />
                                </svg>
                            </div>
                        </div>

                        {/* Step 2 */}
                        <div className='bg-white shadow-xl rounded-2xl p-4 hover:shadow-2xl transition duration-300 group zoomeffect relative'>
                            <div className='mx-auto w-40 mb-2 flex items-center justify-center bg-indigo-100 text-indigo-600 text-2xl rounded-full font-bold group-hover:bg-indigo-600 group-hover:text-white transition'>
                                <img src='assets/icons/vettedtrucker.webp' alt='Vetted Truckers' />
                            </div>
                            <h3 className='text-xl font-semibold text-gray-800 mb-2 staffx group-hover:text-blue-500'>
                                Receive Qualified Truckers
                            </h3>
                            <p className='text-gray-600 text-md font-normal interfont'>
                                We provide verified truckers based on your <br /> business needs, saving you time and
                                risk.
                            </p>
                            <div className='bg-slate-400 w-16 h-16 p-5 text-white rounded-full absolute md:-right-10 md:top-24 z-10'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    fill='none'
                                    viewBox='0 0 24 24'
                                    stroke-width='3'
                                    stroke='currentColor'
                                    className='size-6'
                                >
                                    <path
                                        stroke-linecap='round'
                                        stroke-linejoin='round'
                                        d='M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3'
                                    />
                                </svg>
                            </div>
                        </div>
                        {/* Step 3 */}
                        <div className='bg-white shadow-xl rounded-2xl p-4 hover:shadow-2xl transition duration-300 group zoomeffect'>
                            <div className='mx-auto w-40 mb-2 flex items-center justify-center bg-indigo-100 text-indigo-600 text-2xl rounded-full font-bold group-hover:bg-indigo-600 group-hover:text-white transition'>
                                <img src='assets/review.jpg' alt='Review' />
                            </div>
                            <h3 className='text-xl font-semibold text-gray-800 mb-2 staffx group-hover:text-blue-500'>
                                Review & Contact
                            </h3>
                            <p className='text-gray-600 text-md font-normal interfont'>
                                View profiles, compare, and connect with <br />
                                the best truckers directly, no middlemen involved.
                            </p>
                        </div>
                    </div>
                    <div className='flex justify-center mt-5'>
                        <Link
                            to='/book-demo'
                            className='text-white text-base md:text-lg px-7 py-3 rounded-full bg-[#3c9bf9] border border-[#3c9bf9] hover:bg-white hover:text-[#3c9bf9] font-semibold transition-all'
                        >
                            Book Demo
                        </Link>
                    </div>
                </div>
            </section>
            <img
                src='assets/roadsmallsmall.webp'
                className='object-cover h-[230px] md:h-[550px] lg:h-[750px] 2xl:h-full'
            />
            {/* Operations Section */}

            {/* <div className="bg-gray-300">
            <p className="p-4 md:hidden text-lg">
                Tired of complex logistics slowing you down? Our advanced trucking solutions are designed to streamline your day-to-day,
                making your business run smoother and more efficiently.
                Spend less time on headaches and more time focusing on what matters: increasing your earnings and growing your business.
            </p>
        </div> */}

            {/* Carrier Package Section - FIXED LAYOUT */}
            <section
                className='p-5 md:pr-40 md:pl-20 md:pt-40 md:pb-40 lg:px-32 relative text-left'
                style={{
                    background: "url('assets/graybg.webp')",
                    backgroundSize: 'cover',
                }}
            >
                {/* 50:50 LAYOUT - HEADING/TEXT LEFT, IMAGE RIGHT */}
                <div className='flex flex-col lg:flex-row justify-between items-center gap-12 mb-16'>
                    {/* LEFT: TEXT */}
                    <div className='lg:w-1/2 text-left'>
                        <h2 className='section-titlelEFT leading-tight text-gray-800' style={{ fontSize: 40 }}>
                            Carrier Package for <br />
                            <span className='font-semibold'>STRATEGIC GROWTH</span>
                        </h2>

                        <div className='interfont text-left mb-6 xl:text-lg text-md font-normal mt-6'>
                            Stop searching and start connecting with the best in the business. Our tailored carrier
                            packages provide the ultimate platform to efficiently identify, attract, and hire top-tier
                            drivers who will propel your team forward.
                        </div>
                    </div>

                    {/* RIGHT: IMAGE */}
                    <div className='lg:w-1/2 flex justify-center lg:justify-center'>
                        <img src='assets/samll3dtrucknew2.webp' className='w-[80%] lg:w-[60%] h-auto' alt='Package' />
                    </div>
                </div>

                {/* PACKAGES SECTION (FULL WIDTH BELOW) */}
                {/* <div className='grid grid-cols-1 md:grid-cols-3 gap-8 row-gap-[87px] mt-14 mb-12'> */}
                <div className='grid grid-cols-1 sm:grid-cols-1 xl:grid-cols-3 gap-y-20 gap-x-6 sm:gap-x-8 md:gap-x-10 mt-20 mb-12 px-2 md:px-0'>
                    {packages?.map((pkg) => {
                        const isStarter = pkg.name === 'Starter Package';

                        const accentGradient = isStarter
                            ? 'linear-gradient(135deg, rgb(140, 200, 255), rgb(60, 155, 249))'
                            : 'linear-gradient(135deg, #3c9bf9, #1e3a8a)';
                        const priceCircleShadow = isStarter
                            ? '0 10px 30px rgba(140, 200, 255, 0.45)'
                            : '0 10px 30px rgba(60, 155, 249, 0.45)';

                        return (
                            <div
                                key={pkg._id}
                                className='relative bg-gradient-to-br from-blue-100 to-blue-50 shadow-xl rounded-xl flex flex-col font-sans transition-transform hover:scale-[1.03] duration-300'
                                style={{ overflow: 'visible' }}
                            >
                                {/* Price Circle */}
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '-50px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        width: 110,
                                        height: 110,
                                        background: accentGradient,
                                        borderRadius: '50%',
                                        color: 'white',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '2.6rem',
                                        fontWeight: '800',
                                        boxShadow: priceCircleShadow,
                                        userSelect: 'none',
                                        zIndex: 10,
                                        letterSpacing: '-0.03em',
                                    }}
                                >
                                    ${pkg.price}
                                </div>

                                <div className='pt-24 px-8 pb-8 text-center'>
                                    <h2 className='text-[1.75rem] font-bold mb-3'>{pkg.name}</h2>

                                    <button
                                        onClick={() => navigate(`/package-details/${pkg._id}`)}
                                        className='mt-5 px-8 py-3 rounded-full text-white font-semibold hover:opacity-90 transition'
                                        style={{ background: accentGradient }}
                                    >
                                        VIEW PACKAGE!
                                    </button>

                                    <h3 className='mt-6 mb-3 text-[1.2rem] font-bold text-[#3c9bf9]'>
                                        Package Benefits
                                    </h3>

                                    <ul className='text-left text-slate-700 text-base leading-7 max-h-[180px] overflow-y-auto list-none pl-0'>
                                        {pkg.features.map((feat, i) => (
                                            <li key={i} className='mb-2 flex items-start'>
                                                <i className='fas fa-check-circle text-blue-500 mr-3 mt-1'></i>
                                                {feat}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        );
                    })}

                    {/* SPECIAL PACKAGE */}
                    {specialPackage && (
                        <div
                            className='relative bg-gradient-to-br from-blue-100 to-blue-50 shadow-xl rounded-xl flex flex-col font-sans transition-transform hover:scale-[1.03] duration-300'
                            style={{ overflow: 'visible' }}
                        >
                            <div className='absolute top-4 -right-2 z-20 text-[0.55rem] font-bold uppercase bg-gradient-to-br from-[#d4af37] to-[#f5e27a] px-3 py-1 rounded'>
                                ★ Premium Special
                            </div>

                            <div
                                className='absolute -top-[50px] left-1/2 -translate-x-1/2 w-[110px] h-[110px] z-10 flex items-center justify-center rounded-full bg-gradient-to-br from-[#d4af37] to-[#92700a] text-white text-[2.6rem] font-bold shadow-xl'
                                style={{ boxShadow: '0 10px 30px rgba(212, 175, 55, 0.5)' }}
                            >
                                ${specialPackage.price}
                            </div>

                            <div className='pt-24 px-8 pb-8 text-center'>
                                <h2 className='text-[1.75rem] font-bold mb-3'>{specialPackage.name}</h2>

                                <button
                                    onClick={() => navigate('/special-package')}
                                    className='mt-5 px-8 py-3 rounded-full bg-gradient-to-br from-[#d4af37] to-[#92700a] text-white font-semibold hover:opacity-90 transition'
                                >
                                    VIEW PACKAGE!
                                </button>

                                <h3 className='mt-6 mb-3 text-[1.2rem] font-bold text-[#3c9bf9]'>Package Benefits</h3>

                                <ul className='text-left text-slate-700 text-base leading-7 max-h-[180px] overflow-y-auto list-none pl-0'>
                                    {specialPackage.features.map((feat, i) => (
                                        <li key={i} className='mb-2 flex items-start'>
                                            <i className='fas fa-check-circle text-blue-500 mr-3 mt-1'></i>
                                            {feat}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )}
                </div>

                {/* CENTERED BUTTONS */}
                <div className='flex flex-row gap-3 items-center justify-center mt-12'>
                    <Link
                        onClick={() => window.scrollTo(0, 0)}
                        to='/pricing'
                        className='text-white text-lg px-5 py-2 rounded-md bg-[#3c9bf9] border border-[#3c9bf9] hover:bg-white hover:text-[#3c9bf9] transition-all'
                    >
                        Explore our Packages
                    </Link>

                    <Link
                        onClick={() => window.scrollTo(0, 0)}
                        to='/book-demo'
                        className='text-[#3c9bf9] text-lg px-5 py-2 rounded-md bg-white border border-[#3c9bf9] hover:bg-[#3c9bf9] hover:text-white transition-all'
                    >
                        Book Demo
                    </Link>
                </div>
            </section>

            {/* Dashboard Section */}
            <section
                className='md:px-24 md:py-20 lg:flex bg-white bg-cover '
                style={{
                    backgroundImage: "url('./assets/bluelinebg.jpg')",
                    backgroundPosition: '0px 70px',
                    backgroundSize: 'cover',
                }}
            >
                <img src='assets/moc-imgblue.webp' className='h-auto mx-auto lg:w-2/3 mt-5' alt='iPad Mockup' />
                <div className='pt-5 pb-10 bg-white md:bg-transparent'>
                    <h2
                        className='section-titlelEFT leading-tight text-gray-800 scale-90 md:scale-100 md:mt-20'
                        style={{ fontSize: 40 }}
                    >
                        Drive Smarter,
                        <br /> Earn More <br />
                        <span className='font-semibold' style={{ fontSize: 40 }}>
                            ADVANCED DASHBOARD
                        </span>
                    </h2>
                    <br />
                    <div className='mx-auto  font-normal interfont -mt-5 px-5 md:px-0 xl:text-lg text-md'>
                        It's time to elevate your trucking business. This powerful tool seamlessly builds your
                        professional network, monitors key business metrics, and unlocks new levels of profitability.
                    </div>
                </div>
            </section>

            {/* Newsletter Section */}
            <section
                className='p-5 md:px-40 md:py-32 md:grid grid-cols-3 bg-cover text-left'
                style={{ backgroundImage: "url('./assets/newsleterimgbluesmall.webp')" }}
            >
                <div className='col-span-2 text-white '>
                    <h2 className='font-bold text-2xl'>Sign up for FLEETY NEWSLETTER</h2>
                    <p className='text-md font-light pt-5  font-normal'>
                        Stay up to date on truck driving industry news and see the latest trucking updates
                        <br /> from trucking companies looking for drivers.
                    </p>
                    {popupMessage && (
                        <div className='fixed top-5 right-5 bg-blue-500 text-white px-4 py-2 rounded shadow-lg z-50 transition-opacity duration-500'>
                            {popupMessage}
                        </div>
                    )}
                    <form className='my-5' onSubmit={handleSubmit}>
                        <input
                            type='text'
                            placeholder='Enter Your Name'
                            className='p-2 rounded mr-2 text-black'
                            name='name'
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            required
                        />

                        <input
                            type='email'
                            placeholder='Enter Your Email'
                            className='p-2 rounded mr-2 text-black'
                            name='email'
                            value={formData.email}
                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                            required
                        />

                        <button type='submit' className='p-2 px-5 text-white bg-blue-600 rounded hover:bg-blue-700'>
                            Sign Up!
                        </button>
                    </form>
                    <div className='text-md font-light'>
                        <p>
                            I agree to receive emails from Fleety.com. I understand that I can unsubscribe at any time.
                        </p>
                        <p className='text-white'>
                            By clicking on "Sign Up", you agree to our{' '}
                            <a href='/terms-of-use' className='  hover:underline mx-2' style={{ color: '#a2adb8' }}>
                                Terms of Use
                            </a>
                        </p>
                    </div>
                </div>
            </section>

            {/* Our Clients Section */}
            <section className='py-16 px-4 sm:px-6 lg:px-8 hidden'>
                <div className='max-w-7xl mx-auto'>
                    <div className='text-center mb-12'>
                        <h2 className='section-title font-bold text-gray-900'>
                            Trusted by INDUSTRY LEADERS <b>WORLDWIDE </b>
                        </h2>
                    </div>
                    <div className='relative'>
                        <button
                            id='prevBtn'
                            className='absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 focus:outline-none'
                        >
                            <i className='fas fa-chevron-left text-gray-700'></i>
                        </button>
                        <button
                            id='nextBtn'
                            className='absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 focus:outline-none'
                        >
                            <i className='fas fa-chevron-right text-gray-700'></i>
                        </button>
                        <div id='logoSlider' className='overflow-hidden'>
                            <div className='flex transition-transform duration-300 ease-in-out'>
                                {Array.from({ length: 14 }).map((_, i) => (
                                    <img
                                        key={i}
                                        src={`./assets/client${(i % 2) + 1}.png`}
                                        alt={`Client ${(i % 2) + 1}`}
                                        className='w-40 h-24 object-contain mx-4'
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section
                className='bg-gray-50 py-20 px-4 sm:px-8 lg:px-24'
                style={{ background: 'url(assets/15158smallblue.webp)', backgroundSize: 'cover' }}
            >
                <div className='max-w-7xl mx-auto'>
                    <h2 className='leading-tight text-center text-white staffx' style={{ fontSize: 40 }}>
                        Contact & Support
                    </h2>
                    <br />
                    <h2 className='section-title'></h2>
                    <p className='text-white text-center mb-9 text-xl -mt-6'>
                        We’re here to help. Whether you're a company or trucker, reach out with any questions.
                    </p>
                    <div className='grid grid-cols-1 md:grid-cols-2 mx-auto'>
                        {/* Contact Form */}
                        <form className='bg-white p-4 shadow-xl rounded-2xl space-y-4'>
                            <h3 className='text-xl'>Please fill the form below to get in touch with us.</h3>
                            <div>
                                <label className='block text-gray-700 font-medium mb-2' htmlFor='name'>
                                    Name
                                </label>
                                <input
                                    type='text'
                                    id='name'
                                    name='name'
                                    placeholder='Your name'
                                    className='w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-indigo-500'
                                />
                            </div>
                            <div>
                                <label className='block text-gray-700 font-medium mb-2' htmlFor='email'>
                                    Email
                                </label>
                                <input
                                    type='email'
                                    id='email'
                                    name='email'
                                    placeholder='you@example.com'
                                    className='w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-indigo-500'
                                />
                            </div>
                            <div>
                                <label className='block text-gray-700 font-medium mb-2' htmlFor='message'>
                                    Message
                                </label>
                                <textarea
                                    id='message'
                                    name='message'
                                    rows='2'
                                    placeholder='How can we help you?'
                                    className='w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-indigo-500'
                                ></textarea>
                            </div>
                            <button
                                type='submit'
                                style={{ background: '#3c9bf9' }}
                                className='w-full   text-white font-semibold py-3 rounded-lg hover:bg-black transition'
                            >
                                Send Message
                            </button>
                        </form>
                        {/* Contact Info */}
                        <div className='flex flex-col justify-center space-y-6 text-white'>
                            <div className='flex flex-col gap-12 p-20 bg-black bg-opacity-70 md:w-3/4 md:rounded-r-2xl rounded-b-2xl'>
                                <div className='text-lg'>
                                    <h3 className='font-semibold text-xl mb-2'>Phone Support</h3>
                                    <p>
                                        <strong>📞</strong> +1 (246) 400-0505
                                    </p>
                                    <p className='text-white text-sm'>Available 9 AM – 6 PM (Mon–Sat)</p>
                                </div>
                                <div className='text-lg'>
                                    <h3 className='font-semibold text-xl mb-2'>Email Support</h3>
                                    <p>
                                        <strong>✉️</strong> support@fleetycdl.com
                                    </p>
                                    <p className='text-white text-sm'>We typically respond within 24 hours.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <FooterBlue />
        </>
    );
};

export default HomeBlue;
